import Axios from "./axios";

const resource = "home-testimonials";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}